import React, { useState, useEffect, useContext } from 'react';
import { useHistory } from 'react-router-dom';

import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Grid from '@mui/material/Grid';

import DataTable from '../../../sharedModules/dataTable';

import PageHeader from '../../../sharedModules/layout/PageHeader';
import BackflowJobsFilter from '../components/BackflowJobsFilter';
import LoadingWrapper from '../../../sharedModules/layout/LoadingWrapper';
import ErrorMessage from '../../../sharedModules/layout/ErrorMessage';

import { AuthenticationContext } from '../../../homeModules/auth/contexts/AuthenticationContext';

import { backflowJobGroupsColumns } from '../constants/backflowListColumns';

import axios from '../../../sharedModules/utils/axios.utils';

const BackflowTestApprovalsQueuePage: React.FunctionComponent = () => {
  const history = useHistory();

  const { user } = useContext(AuthenticationContext);

  const [backflowJobGroups, setBackflowJobGroups] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [filterValues, setFilterValues] = useState<any>({
    status_eq: 'pending_approval',
    company_name_eq: 'all',
  });

  const fetchBackflowJobGroups = async (fetchFilterValues = filterValues) => {
    try {
      setLoading(true);
      setError(null);

      const response = await axios.get<string, any>('/backflows/backflow_job_groups', {
        params: {
          'ransack[backflow_dates_scheduled_date_gteq]': fetchFilterValues.backflow_dates_scheduled_date_gteq,
          'ransack[backflow_dates_scheduled_date_lteq]': fetchFilterValues.backflow_dates_scheduled_date_lteq,
          'ransack[status_eq]': 'pending_approval', // Always filter for pending approval
          'ransack[company_name_eq]':
            fetchFilterValues.company_name_eq !== 'all' ? fetchFilterValues.company_name_eq : undefined,
        },
      });

      setBackflowJobGroups(response?.data?.result || []);
    } catch (error) {
      console.error('Error fetching backflow jobs:', error);
      setError('Failed to load backflow jobs. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (user) {
      fetchBackflowJobGroups();
    }
  }, [filterValues, user]);

  const handleRowClick = (row: any) => {
    if (row.backflow_log_id) {
      history.push(`/backflows/${row.backflow_log_id}/spreadsheet`);
    }
  };

  return (
    <Grid container>
      <LoadingWrapper isLoading={loading} message="Loading Backflow Jobs">
        <Grid item xs={12}>
          <PageHeader mainTitle="Backflow Testing" subTitle="Approval Queue" />
        </Grid>
      </LoadingWrapper>
      <Grid item xs={12}>
        <ErrorMessage message={error} />
      </Grid>
      <Grid item xs={12} style={{ marginTop: 20, marginBottom: 20 }}>
        <BackflowJobsFilter
          includeStatus={false}
          filterValues={filterValues}
          setFilterValues={setFilterValues}
          onFilter={fetchBackflowJobGroups}
        />
      </Grid>

      <Grid item xs={12}>
        <Card>
          <CardContent>
            <DataTable
              title=""
              columns={backflowJobGroupsColumns(undefined, true)}
              data={backflowJobGroups}
              onRowClicked={(row: any) => history.push(`/backflow_tests/backflow_job_groups/${row.id}/approve`)}
              dense
              highlightOnHover
              pointerOnHover
              pagination
              paginationPerPage={25}
              paginationRowsPerPageOptions={[25, 50, 100]}
              noHeader
            />
          </CardContent>
        </Card>
      </Grid>
    </Grid>
  );
};

export default BackflowTestApprovalsQueuePage;
